import React from "react";
import "./RegisterPage.css";

const RegisterPage = () => {
  const handleRegisterClick = () => {
    // Redirect to Unstop registration page
    window.open("https://unstop.com/p/encipherx-40-ctf-st-vincent-pallotti-college-of-engineering-and-technology-svpcet-nagpur-1620651?utm_medium=Share&utm_source=adityjad46927&utm_campaign=Online_coding_challenge", "_blank");
  };

  return (
    <div className="register-page">
      {/* Tech Background Elements */}
      <div className="data-streams"></div>
      <div className="tech-elements"></div>

      <div className="register-header">
        <h1>//CTF PLAYER REGISTRATION</h1>
        <p className="register-subtitle">
          Join the Ultimate Cybersecurity Challenge
        </p>
      </div>

      <div className="register-button-container">
        <div className="register-content">
          <p className="register-description">
            Ready to test your cybersecurity skills? Click the button below to
            register for EncipherX 4.0 on Unstop.
          </p>
          <button
            className="register-now-btn"
            onClick={handleRegisterClick}
          >
            REGISTER NOW
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
